import styled from 'styled-components';

export const Service = styled.div`
    width: 675px;
    
    margin-left: auto;
    margin-right: auto;
    padding-top: 160px;
    padding-bottom: 40px;


    //top: 160px;
    //left: 648px;
`;

export const Container = styled.div``;

export const Content = styled.div`
  width: 675px;
  height: 534px;
  /* background: rgba(1, 29, 45, 0.9); */
  /* border: 1px solid rgba(1, 75, 75, 1); */

  position: relative;
  padding: 50px 0;

  > .bg {
    position: absolute;
    z-index: -1000;
    top: -34px;
    bottom: -34px;
    left: -34px;
    right: -34px;
    background-image: url(${require('../img/bg.png')});
    background-size: 100% 100%;
  }

  > .bg-2 {
    position: absolute;
    z-index: -500;
    top: -18px;
    bottom: -18px;
    left: -26px;
    right: -26px;
    background-image: url(${require('../img/decorate.png')});
    background-size: 100% 100%;
  }

  > .close-btn {
    position: absolute;
    display: block;
    width: 102px;
    height: 30px;
    /* background: rgba(4, 20, 29, 0.9); */

    top: -14px;
    right: 0;
    transform: translateY(-100%);

    display: flex;
    align-items: center;
    justify-content: center;

    > .icon {
      width: 14px;
      height: 14px;
      display: block;
    }

    > .text {
      margin-left: 11px;
      line-height: 30px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 255, 255, 1);
    }

    > .bg-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      top: 0;
      left: 0;
      z-index: -1000;

      > .bg {
        width: 100%;
        display: block;
      }
    }
  }

  > .container {
    padding: 0 40px;
    height: 100%;

    box-sizing: border-box;
    overflow: hidden;

    overflow-y: scroll;
    /*控制整个滚动条*/
    ::-webkit-scrollbar {
      background-color: rgba(1, 75, 75, 1);
      width: 4px;
      /* height: 10px; */
      background-clip: padding-box;
    }

    /*滚动条两端方向按钮*/
    ::-webkit-scrollbar-button {
      background-color: rgba(0, 255, 255, 1);
    }

    /*滚动条中间滑动部分*/
    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 255, 255, 1);
      border-radius: 5px;
    }

    /*滚动条右下角区域*/
    ::-webkit-scrollbar-corner {
      background-color: rgba(0, 255, 255, 1);
    }

    > .message-list {
    }
  }
`;

export const Bottom = styled.div`
  margin-top: 26px;
  margin-left: 25px;
  margin-right: 25px;

  padding: 13px 15px;

  border: 1px solid rgba(0, 255, 255, 0.6);

  > .text-input {
    /* width: 617px; */
    width: 100%;
    height: 131px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 4px 32px 3px rgba(6, 10, 74, 0.39);

    padding: 15px 17px;
    box-sizing: border-box;

    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(109, 116, 121, 1);
    line-height: 18px;
  }
`;

export const ButtonFloor = styled.div`
  display: flex;

  > .send {
    display: block;
    margin-left: auto;
    margin-right: 40px;

    width: 131px;
    height: 38px;
    background: rgba(0, 255, 255, 1);

    line-height: 38px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(8, 20, 30, 1);
    line-height: 18px;
  }
`;

export const Message = styled.div``;
